<section data-cy="catalog-skeleton" class="catalog-skeleton-container">
  <ng-container *ngTemplateOutlet="skeletonCards"></ng-container>
  <ng-container *ngTemplateOutlet="skeletonButton"></ng-container>
</section>

<ng-template #skeletonCards>
  <section data-cy="skeleton-grid" class="skeleton-grid">
    <ion-skeleton-text
      *ngFor="let card of cards; let i = index"
      [attr.data-cy]="'skeleton-card-' + i"
      class="skeleton-card"
      animated
    ></ion-skeleton-text>
  </section>
</ng-template>
<ng-template #skeletonButton>
  <ion-skeleton-text
    data-cy="skeleton-button"
    class="skeleton-button"
    animated
  ></ion-skeleton-text>
</ng-template>
